import { render, staticRenderFns } from "./RecordKifu.vue?vue&type=template&id=b7958996&scoped=true&"
import script from "./RecordKifu.vue?vue&type=script&lang=js&"
export * from "./RecordKifu.vue?vue&type=script&lang=js&"
import style0 from "./RecordKifu.vue?vue&type=style&index=0&id=b7958996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7958996",
  null
  
)

export default component.exports